<template>
<el-dialog @close='cancel' title="添加商品" :visible.sync="dialogVisible">
    <div class="add_goods_box">
        <div class="add_goods_search_box">
            <el-input placeholder="输入商品名称" v-model="param.kmcname" clearable></el-input>
            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
        </div>
        <div class="add_goods_tabs_box">
            <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
                <el-tab-pane :label="item.label" :name="item.name" v-for="(item,index) in activeList" :key="index">
                    <el-table :data="tableData" style="width: 100%" :show-header="false" @select="handleSelectionChange" :ref="'multipleTable'+item.name" max-height="300">
                        <el-table-column type="selection" width="30"></el-table-column>
                        <el-table-column label="商品信息">
                            <template slot-scope="scope">
                                <div class="goods_item_box">
                                    <img v-lazy="scope.row.logoPic.furl" alt>
                                    <div>
                                        <p>{{scope.row.kmcname}}</p>
                                        <p :class="scope.row.isFree === 1 ? 'free' : 'toll'">{{scope.row.isFree === 1 ? scope.row.isFreeText : scope.row.salePrice}}</p>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sureAdd()">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
import {findGoodsList} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'shop',
    data() {
        return {
            activeList: [{label: '图文', name: 'article'}, {label: '报告', name: 'report'}, {label: '视频', name: 'video'}, {label: '专题', name: 'spackage'}],
            activeName: 'article',
            param: {
                kmcname: '',
                kmctype: 1
            },
            page: {
                page: 0,
                pageSize: 10,
                pageCount: 0
            },
            dialogVisible: false,
            tableData: [],
            selectedResult: [],
            flag: true,
            scrollTop: 0 // 上一次滚动距离
        }
    },
    mounted() {},
    methods: {
        openDialog(selectedResult) {
            this.tableData = []
            this.selectedResult = $.extend(true, [], selectedResult)
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.name = ''
            this.page = {
                page: 0,
                pageSize: 10,
                pageCount: 0
            }
            this.dialogVisible = false
        },
        handelQuery() {
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        // 添加分组弹窗Tabs
        handleClick(tabName) {
            switch (tabName) {
            case 'article':
                this.param.kmctype = 1
                break
            case 'report':
                this.param.kmctype = 2
                break
            case 'video':
                this.param.kmctype = 4
                break
            case 'spackage':
                this.param.kmctype = 5
                break
            }
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        // 获取不同类型下商品列表
        _getList() {
            let selectedResult = this.selectedResult
            this.page.page++
            this.setLoading(true)
            findGoodsList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = this.tableData.concat(data.data.content)
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    if (selectedResult.length) {
                        this.tableData.forEach(obj1 => {
                            selectedResult.forEach(obj2 => {
                                if (obj1.kmcinnerid === obj2.objectid) {
                                    this.$nextTick(() => {
                                        this.$refs[`multipleTable${this.activeName}`][0].toggleRowSelection(obj1)
                                    })
                                }
                            })
                        })
                    }
                    this.setLoading(false)
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-table__body-wrapper').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.page.page < _this.page.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getList()
                                }
                            }
                        })
                    })
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
            this.setLoading(true)
        },
        handleSelectionChange(selection, row) {
            let flag = true
            this.selectedResult.forEach((obj1, index1) => {
                if (obj1.objectid === row.kmcinnerid) {
                    flag = false
                    // this.selectedResult.splice(index1, 1)
                    delete this.selectedResult[index1]
                }
            })
            if (flag) {
                this.selectedResult.push({
                    objectid: row.kmcinnerid,
                    objectname: row.kmcname,
                    kmctype: row.kmctype,
                    viewcount: row.viewcount,
                    uprice: row.uprice,
                    saleprice: row.saleprice,
                    furl: row.logoPic.furl,
                    desc: row.desc
                })
            }
            this.selectedResult = this.selectedResult.filter(obj => obj)
        },
        // 确定添加商品
        sureAdd() {
            this.$emit('setShop', this.selectedResult)
            this.cancel()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.add_goods_box {
    .add_goods_search_box {
        display: flex;
        margin-bottom: 10px;
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 36px;
        }
        .el-input__icon {
            line-height: 36px;
        }
        .el-button,
        .el-button--mini {
            height: 36px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .el-table{
            min-height: 300px;
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            & > img {
                width: 74px;
                min-width: 74px;
                height: 42px;
                margin-right: 10px;
            }
            & > div {
                & > p:nth-of-type(1) {
                    color: rgba(48, 49, 51, 1);
                    line-height: 18px;
                    margin-bottom: 4px;
                    width: 420px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                }
                & > p:nth-of-type(2) {
                    line-height: 20px;
                }
                .free {
                    color: rgba(64, 158, 255, 1);
                }
                .toll {
                    color: #f56c6c;
                }
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .el-tabs__header {
        padding-right: 20px;
    }
}
</style>
